import { render } from "./SkillsView.vue?vue&type=template&id=94e6b6e8"
import script from "./SkillsView.vue?vue&type=script&lang=js"
export * from "./SkillsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__